/** File metadata `type` stored with platform file uploads for the full brand logo. */
export const COMPANY_LOGO_UPLOAD_FILE_TYPE = 'company-logo-large';

/** File metadata `type` for the compact glyph / logomark (`personalization.logoSmall`). */
export const COMPANY_GLYPH_UPLOAD_FILE_TYPE = 'company-logo-small';

const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

/**
 * @param {string | undefined | null} value Stored logo reference (ObjectId or URL).
 * @returns {boolean}
 */
export function isPlatformFileId(value: string | undefined | null): boolean {
  const trimmed = value?.trim() ?? '';
  return OBJECT_ID_PATTERN.test(trimmed);
}
